import type { ReactNode } from "react";

export function ChatComposerContent({
  canWrite,
  automaticPrompt,
  pendingPrompt,
  suggestions,
  children,
}: {
  canWrite: boolean;
  automaticPrompt: ReactNode;
  pendingPrompt: ReactNode;
  suggestions: ReactNode;
  children: ReactNode;
}) {
  // The composer must keep its sibling position across access changes to preserve DOM state.
  return (
    <>
      {canWrite && automaticPrompt}
      {canWrite ? pendingPrompt || suggestions || children : children}
    </>
  );
}
